import { createApp } from 'vue';
import { get, post, getByUrl, postByUrl,post2 ,get2} from './http-service';
export let globalObj = { isLoading: false, token: '' };
export let authService = { redirectUrl: '/' };
import axios from 'axios';

//发射器
export let loginEmmiter = createApp();

/**
 * 获取资源的默认封面图
 * @param {string} resTypeId - 资源类型ID
 * @returns {string} - 封面图路径
 */
export const getDefaultThumbnail = (resTypeId = '') => {
  const thumbnailConfig = window.config.thumbnail || [];
  const defaultConfig = thumbnailConfig.find(item => item.resTypeId === '') || { thumbnail: './thumbnail/default/default.png' };
  
  if (!resTypeId) {
    return defaultConfig.thumbnail;
  }

  const typeConfig = thumbnailConfig.find(item => 
    item.resTypeId.toLowerCase() === resTypeId.toLowerCase()
  );
  return typeConfig ? typeConfig.thumbnail : defaultConfig.thumbnail;
};

/**
 * 获取资源的实际封面图
 * @param {string} resTypeId - 资源类型ID
 * @param {string} thumbnail - 资源自身的封面图
 * @returns {string} - 最终使用的封面图路径
 */
export const getThumbnail = (resTypeId = '', thumbnail = '') => {
  if (thumbnail) {
    return thumbnail;
  }
  return getDefaultThumbnail(resTypeId);
};

//1、点击顶部右边按钮显示一级分类
export const getParentInfosApi = async function (params) {
  return post('product/resCategors/getParentInfos', params);
};
//获取顶部导航
export const getMenuRescategory = async function (params) {
  return post('/user/menu/getSublevelInfo', params);
};
//乐谱租赁选择的栏目(获取二级分类)
export const getSublevelInfoApi = async function (params) {
  return post('product/resCategors/getSublevelInfo', params);
};
//获取轮播图
export const getPosterlistApi = async function (params) {
  return post('Service/PavilionsService/getPosterlist', params);
};
//首页推荐最新等
export const getResTopListApi = async function (params) {
  return post('Service/PavilionsService/getResTopList', params);
};
//搜索，专辑等
export const getRYResourceListApi = async function (params) {
  return post('Service/RYOMService/getResourceList', params);
};
//获取名家列表
export const getAuthorListApi = async function (params) {
  return post('Service/RYOMService/getAuthorList', params);
};
//获取名家详情
export const getAuthorDetailsApi = async function (params) {
  return post('Service/RYOMService/getAuthorDetails', params);
};
//查看资源详情
export const getRYOMResourceDetailsApi = async function (params) {
  return post('Service/RYOMService/getResourceDetails', params);
};
//新增访问记录
export const addHistoryApi = async function (params) {
  return post(`Service/History/addHistory`, params);
};
//获取资源分类
export const getCategoryByResApi = async function (params) {
  return get('/Service/PavilionsService/getCategoryByRes/'+params);
};
//新增搜索记录
export const addSearchHistoryApi = async function (params) {
  return post('Service/History/addSearchHistory', params);
};
//获取自定义模板
export const getTemplateFieldApi = async function (params) {
  return post('/template/getTemplateField', params);
};
//查看活动详情
export const getActivityDetailsApi = async function (params) {
  return post('Service/RYOMService/getActivity', params);
};
//获取相关资源
export const getRYResRelationsApi = async function (params) {
  return post('/Service/PavilionsService/getRYResRelations', params);
};
//获取相关作品
export const getRelationsApi = async function (params) {
  return post('/Service/RYOMService/getRelations', params);
};
//awtSupport预览
export const awtSupportResPreviewApi = function (params) {
  return post('/Service/PavilionsService/awtSupportResPreview', params)
};
// 获取新闻列表
export const getNewslist = async function (params) {
  return post('/Service/PavilionsService/getNewslist', params);
};
// 获取手机验证码
export const getMobileVerifyApi = async function (params) {
  return post(`admin/pusers/getMobileVerify`, params);
};

// 手机验证码登录
export const loginWebForPhoneApi = async function (params) {
  return post(`admin/pusers/loginWebForPhone`, params);
};
//获取各乐谱价格
export const getResPriceListApi = async function(params){
  return post('/Service/PavilionsService/getResPriceList',params)
};
//生成订单
export const addOrderApi = async function(params){
  return post('/Service/ShopOrderService/addOrder',params)
};
//生成带份数的订单
export const addOrderNumberApi = async function(params){
  return post('/Service/ShopOrderService/addOrder', params);
};
//微信支付
export function getWXopenid (url) {
  return get('pay/authorize?returnUrl='+ url)
};
//支付 微信浏览器
export function getWXplay (orderId, openId) {
  return post('pay/createWx?outTradeNo=' + orderId + '&openId=' + openId, {})
};
//获取订单
export function getOrder(params) {
  return post(`Service/ShopOrderService/getOrder`, params);
}
//获取重新支付订单信息
export const getRePayOrderApi = function (params) {
  return post(`/Service/ShopOrderService/getRePayOrder`, params);
};

//获取用户订单
export function getMyShopOrderListApi(params) {
  return post(`Service/ShopOrderService/getMyShopOrderList`, params);
};
//用户登录
export const loginApi = function (params) {
  return post(`admin/pusers/loginWeb`, params);
};

//单点登录
export const ssologinApi = async function (params) {
  return post(`admin/pusers/ssologin`, params);
};
//获取我的名片
export const getUserCardApi = function (userId) {
  return get('Service/UserCard/getUserCard/' + userId);
};
//获取全部的消息
export const getMessageListApi = function (params) {
  return post('/Service/Push/getMessageList', params);
};
//获取未读信息数量
export const getUnReadCountApi = function (userId) {
  return get('/Service/Push/getUnReadCount/' + userId);
};
//设置消息为已读
export const updateStatusApi = function (params) {
  return post('/Service/Push/updateStatus', params);
};
//获取用户历史行为
export const getHistoryListApi = async function (params) {
  return post('/Service/PavilionsService/getHistoryList', params);
};
//获取点赞、关注等信息
export const likedListApi = async function (params) {
  return post('/Service/Liked/likedList', params);
};
//关注调用接口
export const addLikedApi = async function (params) {
  return post('Service/Liked/addLiked', params);
};
//验证码
export const verifyApi = function () {
  return get(`admin/pusers/getVerify`);
};

// 移除收藏
export const deleteFavoriteApi = async function (params) {
  return post(`Service/Favorite/deleteFavorite`, params);
};
//查看我的作品总数
export const getRYOMResCountApi = async function (params) {
  return post('Service/RYOMService/getAuthorResCount', params);
};
//猜你喜欢
export const getRYHotResourceListApi = async function (params) {
  return post('/Service/PavilionsService/getRYHotResourceList', params);
};
// 加入收藏
export const addFavoriteApi = async function (params) {
  return post(`Service/Favorite/addFavorite`, params);
};
//取消关注（收藏除外）
export const cancelLikedApi = async function (params) {
  return post('/Service/Liked/cancelLiked', params);
};
//取消收藏除
export const cancelFavoriteApi = async function (params) {
  return post('/Service/Favorite/cancelFavorite', params);
};
// 收藏列表
export const getFavoriteListApi = async function (params) {
  return post(`Service/Favorite/getFavoriteList`, params);
};
//获取心愿单（留言）
export const getListApi = async function (params) {
  return post('/Service/CommentService/getList', params);
};
//增加心愿
export const addCommentApi = async function (params) {
  return post('/Service/CommentService/add', params);
};
// 设置我的名片
export const generateUserCardApi = async function (params) {
  return post('/Service/UserCard/generateUserCard', params);
};
//修改密码
export const modifyWebRYApi = async function (params) {
  return post('/admin/pusers/modifyWebRY', params);
};
//获取手机验证码
export const mobVerifyApi  = async function (params) {
  return post('/admin/pusers/getMobVerify', params);
};
//获取邮箱验证码
export const emailVerifyApi = async function (params) {
  return post('/admin/pusers/getEmailVerify', params);
};
//修改用户信息
export const modifyWebApi = async function (params) {
  return post('/admin/pusers/modifyWeb', params);
};
//微信分享
export const getShareUrlApi = async function (params) {
  return get('/service/wechat/getShareUrl', params);
};
//新增个人专辑
export const addTreeURL = async function (params) {
  return post('/Service/Tree/addTree', params);
};
//删除个人专辑
export const deleteTreeApi = async function (params) {
  return post('/Service/Tree/deleteTree', params);
};
//获取个人专辑
export const getTreeInfosApi = async function (params) {
  return post('/Service/Tree/getTreeInfos', params);
};
//获取资源库谱音同步的信息
export const awtSupportMusicPlayInfoApi = async function(params){
  return post('/Service/PavilionsService/awtSupportMusicPlayInfo', params);
}
//获取我的代表作
export const getCompListApi = async function (params) {
  return post('/admin/userresource/getCompList', params);
};
//代表作排序
export const updateCompListorderApi = async function (params) {
  return post('/admin/userresource/updateCompListorder', params);
};
//新增代表作
export const addCompApi = async function (params) {
  return post('/admin/userresource/addComp', params);
};
//修改代表作
export const updateCompApi = async function (params) {
  return post('/admin/userresource/updateComp', params);
};
//删除代表作
export const deleteCompApi = async function (params) {
  return post('/admin/userresource/deleteComp', params);
};
//获取作品的作者
export const getSameNameResListApi = async function(params){
  return post('/Service/RYOMService/getSameNameResList', params);
};
//获得首页的数据
export const getHomeJsonApi = async function (type) {
  return get2('/data/home/'+type+'.json');
};
//获取静态数据
export const getStaticJsonApi = async function (params) {
  return get2('/data/'+params+'.json');
};

//调用上传接口保存
export const addUploadApi = async function (params) {
  return post(`Service/UploadService/addUpload`, params);
};

//获取我提交的
export const getUploadApi = async function (params) {
  return post(`Service/UploadService/getMyUploadByuser`, params);
};
//获取新闻详情
export const getNesDetailApi = (params) =>{
  return post('/Service/PavilionsService/getNewsDetails',params)
}
//获取首页栏目的数据
export const getHomeCatJsonApi = async function (CatId,type) {
  return get2('/data/column/'+CatId+'/'+type+'.json');
};
export const awtSsoRefreshtokenApi = function (token) {
  return get(`admin/pusers/omSsoRefreshtoken?accesstoken=` + token);
};
const getMobileVerifyCodeURL = window.config.getMobileVerifyCodeApi;
export const getMobileVerifyCodeApi = async function (params) {
  return post2(getMobileVerifyCodeURL, params);
};
export const bindUserMobileApi = async function (params) {
  return post('admin/pusers/bindUserMobile', params);
};
export const getAwtSsoClientinfoApi = function () {
  return get(`/admin/pusers/getAwtSsoClientinfo?id=`+window.config.ssoClientId);
};

//获取畅言相关配置(加密过)
export const getAccountApi = async function () {
  return get(`Service/ChangYan/getAccount`);
};

//解密畅言配置
export const getDecodeApi = async function (params) {
  return post(`getDecode`,params);
};

export const getAwtSsoAccesscodeApi = function (appid, timestamp, redirect) {
  const params = {
    appid: appid,
    timestamp: timestamp,
    redirect: redirect,
  };
  return get(`admin/pusers/getAwtSsoAccesscode`, params);
};

export const getVailIPApi = async function () {
  return post(`Service/PavilionsService/getVailIP`, {});
};

export const getTokenApi = async function (id) {
  return get(`admin/pusers/getToken` + id);
};

export const delayTokenTimeApi = async function (params) {
  return post(`admin/pusers/delayTokenTime`, params);
};

export const getUserInfo = function () {
  return JSON.parse(localStorage.getItem('rym-app-user'));
};

export const setUserInfo = function (s) {
  return localStorage.setItem('rym-app-user', JSON.stringify(s));
};

export const removeUserInfo = function () {
  return localStorage.removeItem('rym-app-user');
};

export const webChatAccessTokenApi = function (params) {
  return get(`service/wechat/webChatAccessToken`, params);
};

export const getWebChatUserInfoApi = function (params) {
  return get(`service/wechat/webChatUserInfo?id=om-app`, params);
};

//注册获取手机验证码
export const getMobileVerifyRegisterApi = function (params) {
  return post(`admin/pusers/getMobileVerifyRegister`, params);
};

//注册
const registerURL = `${window.config.baseUrl}/admin/pusers/addRegisterUser`;
export const registerApi = function (params) {
  const instance = axios.create({
    withCredentials: true,
  });
  return instance.post(registerURL, params);
};
